import config from '@efdigital/ll-admin-v2/config/environment';
import type { TemplateOnlyComponent } from '@ember/component/template-only';
import { LinkTo } from '@ember/routing';

import homeImage from '../assets/images/home.jpg';
import logo from '../assets/images/hult-ashridge-logo-white.svg';
import { HelpButton } from '../components/application/help-button.gts';
import HomeWhatsNew from '../components/application/whats-new.gts';

const ADMIN_V1_URL = config['ll-apps'].adminV1;

const Index: TemplateOnlyComponent = <template>
  <header class="text-bg-primary">
    <div
      class="container py-3 py-xxl-4 d-flex flex-row align-items-center justify-content-between gap-3"
    >
      <img
        src={{logo}}
        alt="Hult Ashridge Executive Education"
        class="img-fluid mw-400px"
      />
    </div>
  </header>
  <div class="container py-5">
    <div class="row align-items-center mb-5">
      <div class="col-lg-6 mb-4 mb-lg-0">
        <h1 class="mb-3">Welcome to Admin<span
            class="text-hultashridge-heritage"
          >·2</span></h1>
        <p class="lead mb-5 lh-sm">
          Your hub for managing programs, publishing content, and configuring
          access to our digital portfolio.
        </p>

        <div class="d-flex flex-column gap-4 me-lg-5">
          <LinkTo
            @route="programs"
            class="btn btn-primary btn-lg w-100 py-3 d-flex align-items-center justify-content-center gap-2"
            data-test-home-programs
          >
            <iconify-icon inline icon="ph:tree-view" class="fs-4" />
            Manage Programs
          </LinkTo>
          <LinkTo
            @route="library.clients"
            class="btn btn-primary btn-lg w-100 py-3 d-flex align-items-center justify-content-center gap-2"
            data-test-home-clients
          >
            <iconify-icon inline icon="ph:handshake" class="fs-4" />
            Manage Clients
          </LinkTo>
        </div>
      </div>
      <div class="d-none d-lg-block col-lg-6">
        <img
          src={{homeImage}}
          alt="People arranging post-it notes"
          class="img-fluid rounded-4 shadow ll-admin-v2-home-image"
        />
      </div>

    </div>

    <div class="row mb-5">
      <div class="col-lg-8">
        <HomeWhatsNew />
      </div>
      <div class="col-lg-4">
        <div class="d-flex flex-column gap-4">
          <div
            class="alert alert-secondary border-start border-secondary border rounded-4"
            role="alert"
          >
            <div class="d-flex align-items-center gap-3">
              <iconify-icon
                inline
                icon="ph:traffic-sign-duotone"
                class="text-secondary flex-shrink-0 flex-grow-0 fs-1"
              ></iconify-icon>
              <div class="flex-grow-1">
                <h4 class="h5">Supported Features and Backwards Compatibility</h4>
              </div>
            </div>
            <p class="mb-0 mt-2 lh-sm small">
              Admin&nbsp;2 offers a streamlined, modern interface for creating
              and managing programs and clients. For maintaining existing
              cohorts (created before Admin&nbsp;2), user permission management,
              assessments, contacts, and other features, please
              <a
                href={{ADMIN_V1_URL}}
                target="_blank"
                rel="noopener noreferrer"
                class="alert-link"
              >
                <strong>use the legacy admin interface
                  <iconify-icon
                    inline
                    icon="ph:arrow-square-in-bold"
                  /></strong>
              </a>
            </p>
          </div>

          <HelpButton class="btn btn-outline-secondary">
            <iconify-icon inline icon="ph:book-open-bold" />
            User Guide
          </HelpButton>

          <p class="lh-sm">
            Need help or have feedback? Email
            <a
              href="mailto:engineering.team@hultashridge.com"
            >engineering.team@hultashridge.com</a>
          </p>
        </div>
      </div>
    </div>

  </div>
</template>;

export default Index;
